import { Core } from "@faire/design-tokens";
import { getSpacing } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import styled, { css } from "styled-components";

import { TrackedLink } from "@faire/retailer/components/TrackedLink";

export const ControlsOverlay = styled.div`
  position: absolute;
  z-index: 3;
  width: 100%;
  height: 100%;
`;

export const TrackedProductLink = styled(TrackedLink)`
  width: 100%;
  display: block;
  position: relative;
`;

export const ProductError = styled.div`
  background-color: red;
  text-align: center;
  color: ${Core.text.default};
`;

export const ImageContainer = styled.div`
  position: relative;
`;

export const RetailInfoContainer = styled.div`
  flex: 1;
  padding: ${getSpacing(12, 0, "1x", 0)};
`;

export const ProductLine = styled.div<{ $noSpacing?: boolean }>`
  margin-bottom: 10px;
  max-width: 100%;
  ${({ $noSpacing }) =>
    $noSpacing
      ? css`
          margin-bottom: 4px;
        `
      : ""};
`;

export const ProductLineFlexibleHeight = styled(Typography).attrs({
  variant: "paragraphSansMedium",
})`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
  white-space: normal;
`;

export const NotifyMeWrapper = styled.div`
  position: absolute;
  bottom: 8px;
  right: 8px;
  z-index: 5;
`;
